class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    if (!this.drawer) return;
    
    this.body = document.getElementById('CartDrawerBody');
    this.initEventListeners();
  }

  initEventListeners() {
    // Open drawer
    document.querySelectorAll('.js-cart-drawer-toggle').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close drawer
    document.querySelectorAll('.js-cart-drawer-close').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // Quantity adjustments inside drawer
    this.drawer.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-cart-drawer-qty-minus')) {
        this.updateQuantity(e.target.dataset.line, -1);
      }
      if (e.target.classList.contains('js-cart-drawer-qty-plus')) {
        this.updateQuantity(e.target.dataset.line, 1);
      }
      if (e.target.classList.contains('js-cart-drawer-remove')) {
        e.preventDefault();
        this.changeQuantity(e.target.dataset.line, 0);
      }
    });

    // Handle Add to Cart submissions
    const bindForms = () => {
      const productForms = document.querySelectorAll('form[action="/cart/add"]');
      productForms.forEach(form => {
        if (!form.hasAttribute('data-cart-drawer-bound')) {
          form.setAttribute('data-cart-drawer-bound', 'true');
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.addToCart(form);
          });
        }
      });
    };
    
    bindForms();
    // Re-bind occasionally in case forms are dynamically injected
    setInterval(bindForms, 1000);
  }

  open() {
    this.drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async addToCart(form) {
    const formData = new FormData(form);
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.innerText;
    
    submitBtn.disabled = true;
    submitBtn.innerText = 'Adding...';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        await this.refresh();
        this.open();
      } else {
        const error = await response.json();
        alert(error.description || 'Error adding to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerText = originalText;
    }
  }

  updateQuantity(line, delta) {
    const input = this.drawer.querySelector(`.js-cart-drawer-qty-input[data-line="${line}"]`);
    if (!input) return;
    const newQty = parseInt(input.value) + delta;
    if (newQty >= 0) {
      this.changeQuantity(line, newQty);
    }
  }

  async changeQuantity(line, quantity) {
    this.drawer.style.pointerEvents = 'none';
    this.drawer.style.opacity = '0.7';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (response.ok) {
        await this.refresh();
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
    } finally {
      this.drawer.style.pointerEvents = 'auto';
      this.drawer.style.opacity = '1';
    }
  }

  async refresh() {
    try {
      const response = await fetch(window.location.pathname + '?section_id=cart-drawer');
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      const newDrawerBody = html.getElementById('CartDrawerBody');
      const newDrawerFooter = html.querySelector('.cart-drawer__footer');
      
      if (newDrawerBody) {
        this.body.innerHTML = newDrawerBody.innerHTML;
        
        // Handle footer
        const existingFooter = this.drawer.querySelector('.cart-drawer__footer');
        if (existingFooter && newDrawerFooter) {
          existingFooter.innerHTML = newDrawerFooter.innerHTML;
        } else if (!existingFooter && newDrawerFooter) {
          this.drawer.querySelector('.cart-drawer__content').appendChild(newDrawerFooter);
        } else if (existingFooter && !newDrawerFooter) {
          existingFooter.remove();
        }
        
        this.updateHeaderCount();
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
  }

  updateHeaderCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        const badge = document.querySelector('.primal-header__cart-badge');
        if (cart.item_count > 0) {
          if (badge) {
            badge.innerText = cart.item_count;
          } else {
            const cartIcon = document.querySelector('.primal-header__cart-count');
            if (cartIcon) {
              const newBadge = document.createElement('span');
              newBadge.className = 'primal-header__cart-badge';
              newBadge.innerText = cart.item_count;
              cartIcon.appendChild(newBadge);
            }
          }
        } else if (badge) {
          badge.remove();
        }
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartDrawer();
});
